import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, Transition as _Transition } from "vue"

const _hoisted_1 = {
  "data-cy": "game-name",
  class: "text-2xl text-center"
}
const _hoisted_2 = { class: "flex border-b border-gray-500 text-center text-xs w-auto mb-2" }
const _hoisted_3 = { class: "left-col" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "started:", -1)
const _hoisted_5 = { class: "ml-1 italic" }
const _hoisted_6 = { class: "right-col" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "updated:", -1)
const _hoisted_8 = { class: "ml-1 italic" }
const _hoisted_9 = { "data-cy": "game-players" }
const _hoisted_10 = { class: "left-col text-lg" }
const _hoisted_11 = { class: "right-col text-lg font-mono" }
const _hoisted_12 = { class: "flex m-1" }
const _hoisted_13 = { class: "flex m-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_archive_icon = _resolveComponent("archive-icon")!
  const _component_unarchive_icon = _resolveComponent("unarchive-icon")!
  const _component_delete_icon = _resolveComponent("delete-icon")!
  const _component_swipe_out = _resolveComponent("swipe-out")!

  return (_openBlock(), _createBlock(_Transition, { name: "remove" }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_component_swipe_out, {
        class: _normalizeClass(["card game-card bg-gray-300", { left: _ctx.revealed === 'left', right: _ctx.revealed === 'right', archived: _ctx.game.archived }]),
        onRightRevealed: _cache[3] || (_cache[3] = ($event: any) => (_ctx.revealed = 'right')),
        onLeftRevealed: _cache[4] || (_cache[4] = ($event: any) => (_ctx.revealed = 'left')),
        onClosed: _cache[5] || (_cache[5] = ($event: any) => (_ctx.revealed = '')),
        key: _ctx.game.id
      }, {
        default: _withCtx(({ item, index, revealLeft, close }) => [
          _createElementVNode("div", {
            class: "cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('select', _ctx.game)))
          }, [
            _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.game.name), 1),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.started), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.lastPlayed), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.game.players, (player) => {
                return (_openBlock(), _createElementBlock("div", {
                  "data-cy": "game-player",
                  class: _normalizeClass(["flex", { 'font-bold text-green-700': _ctx.winner(player) }]),
                  key: player.id
                }, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(player.name), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(player.score), 1)
                ], 2))
              }), 128))
            ])
          ])
        ]),
        right: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "btn square warn",
              "data-cy": "archive-game",
              title: "archive",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('archive', _ctx.game)))
            }, [
              (!_ctx.game.archived)
                ? (_openBlock(), _createBlock(_component_archive_icon, { key: 0 }))
                : (_openBlock(), _createBlock(_component_unarchive_icon, { key: 1 }))
            ])
          ])
        ]),
        left: _withCtx(() => [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              class: "btn square alert",
              "data-cy": "delete-game",
              title: "remove",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('remove', _ctx.game)))
            }, [
              _createVNode(_component_delete_icon)
            ])
          ])
        ]),
        _: 1
      }, 8, ["class"]))
    ], undefined, true),
    _: 1
  }))
}